export default __webpack_public_path__ + "static/media/intro1.0f67e7f5.mp3";